import { render, staticRenderFns } from "./company-info-basic.vue?vue&type=template&id=4551d825&scoped=true&"
import script from "./company-info-basic.vue?vue&type=script&lang=js&"
export * from "./company-info-basic.vue?vue&type=script&lang=js&"
import style0 from "./company-info-basic.vue?vue&type=style&index=0&id=4551d825&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4551d825",
  null
  
)

export default component.exports